import { render, staticRenderFns } from "./LoginSsoPage.vue?vue&type=template&id=958a828a"
import script from "./LoginSsoPage.vue?vue&type=script&lang=ts"
export * from "./LoginSsoPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports